<template>
  <div id="app">
    <!-- <router-view /> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>
<script>
import routes from "@/router/routes";
import sensors from 'sa-sdk-javascript';

const baseParams = {
		// 用户Tenant ID
		lookstar_tenant_id: '6c3fa2b0-c5be-471d-8c73-4a831e22aea9'
	};
export default {

  watch: {
    $route(newData) {
      this.handleRouter(newData);
    },
  },

  created() {
    this.handleRouter(this.$route);
  },
  mounted() {
			// this.init();
		},
  methods: {
    init() {
      sensors.init({
        show_log: true,
        server_url: "https://analytics.lookstar.com.cn",
        is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
        use_client_time: true,
        send_type: "image",
        preset_properties: {
          latest_referrer_host: true,
          latest_landing_page: true,
        },
        heatmap: {
          //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
          clickmap: "default", // 标签：a、button、input
          //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
          scroll_notice_map: "default", // 页面停留4秒滚动
          //此参数针对预置 $WebClick 事件（包括 quick('trackHeatMap') quick('trackAllHeatMap') 触发的）生效。
          collect_element: function (element_target) {
            // 如果这个元素有属性sensors-disable=true时候，不采集。
            if (
              element_target.getAttribute("data-sensors-disable") === "true"
            ) {
              return false;
            } else {
              return true;
            }
          },
          custom_property: function (element_target) {
            let params = {
              item_key:
                element_target.getAttribute("data-sensors-item-key") || null,
              lookstar_tag:
                element_target.getAttribute("data-sensors-lookstar-tags") ||
                null,
            };

            return params;
          },
        },
      });

      // 判断是否填写的uuid。
      if (
        /^[0-9a-z]{8}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{4}-[0-9a-z]{12}$/.test(
          baseParams.lookstar_tenant_id
        )
      ) {
        // 注册公共属性
        sensors.registerPage(baseParams);

        sensors.use("SensorsChannel"); // 开启来源追踪（分享、广告等）
        sensors.quick("autoTrack"); // 用于自动采集 $pageview 事件。
        sensors.use("PageLeave", {
          heartbeat_interval_time: 5,
        }); // 设置页面浏览时长自定义属性 page_title 为 '我的标题'，并设置页面浏览时长心跳记录刷新时间为 5 秒。
        sensors.use("PageLoad");

        sensors.bind(
          "identity_mp_openid",
          this.$localStorage.getItem("openid")
        );
        sensors.bind(
          "identity_mp_unionid",
          this.$localStorage.getItem("unionid")
        );

        this.get_lockstar();
      } else {
        console.error("lookstar_tenant_id配置错误！");
      }
    },
    get_lockstar() {
      this.$http
        .get(
          `/api/platform/send/openid?openid=${
            this.$localStorage.getItem("openid") || ""
          }`
        )
        .then((res) => {
          if (res.data.errcode == 10301) {
            return;
          } else {
            sensors.bind("identity_mobile", `${res.data.plaintext_data?.phone}`);
            // sensors.track('user_register_success');
            // this.formData.is_lookstart = 1;
            // formData.is_lookstart = 1;
            // this.formData.name = res.data.full_name;
            // this.formData.phone = res.data.plaintext_data.phone;
            // this.formData.email = res.data.plaintext_data.email;
            // this.formData.company = res.data.company;
            // this.formData.position = res.data.job;
          }
        });
    },
    handleRouter(newData) {
      let curRouter = {};
      routes.forEach((item) => {
        if (item.path == newData.path) {
          curRouter = item;
        }
      });
      console.log("title2222-----",curRouter.title);
      document.title = curRouter.title || "";
    },
    prohibitAndroidAdjustmentSize() {
      if (
        typeof WeixinJSBridge == "object" &&
        typeof WeixinJSBridge.invoke == "function"
      ) {
        this.handleFontSize();
      } else {
        if (document.addEventListener) {
          document.addEventListener(
            "WeixinJSBridgeReady",
            this.handleFontSize,
            false
          );
        } else if (document.attachEvent) {
          document.attachEvent("WeixinJSBridgeReady", this.handleFontSize);
          document.attachEvent("onWeixinJSBridgeReady", this.handleFontSize);
        }
      }
    },
    handleFontSize() {
      // 设置网页字体为默认大小
      WeixinJSBridge.invoke("setFontSizeCallback", {
        fontSize: 0,
      });
      // 重写设置网页字体大小的事件
      WeixinJSBridge.on("menu:setfont", function () {
        WeixinJSBridge.invoke("setFontSizeCallback", {
          fontSize: 0,
        });
      });
    },
  },
};
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline-style: none;
  list-style: none;
}

 #app{
  position: relative;
  background: #ffffff !important;
  min-height: 100vh;
}
// ::v-deep body {
//   position: relative;
//   background: #edebea !important;
//   min-height: 100vh;
// }

textarea,
input {
  display: block;
  resize: none;
  outline: none;
  border: none;
  background-color: transparent;
  -webkit-appearance: none;
  appearance: none;
  border-radius: 0;
}

textarea::-webkit-input-placeholder,
input::-webkit-input-placeholder {
  color: #cbcbcb;
}

textarea::input-placeholder,
input::input-placeholder {
  color: #cbcbcb;
}

input:disabled,
textarea:disabled {
  -webkit-opacity: 1;
  opacity: 1;
}

input.placeholder_em::-webkit-input-placeholder {
  font-style: italic;
}

input.placeholder_em::input-placeholder {
  font-style: italic;
}

.wechat_scroll {
  width: 100%;
  height: 100vh;
}
.__line1 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
.__line2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
}
.flex-c {
  display: flex;
  align-items: center;
}
.flex-c-c {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flex-c-sb {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.__line3 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notScroll {
  &::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: none;
    background-color: transparent;
    width: 0;
    height: 0;
    display: none !important;
  }
  &::-webkit-scrollbar-thumb {
    -webkit-box-shadow: none;
    background-color: transparent;
    display: none !important;
  }
  &::-webkit-scrollbar-button {
    background-color: transparent;
    display: none !important;
  }
  &::-webkit-scrollbar-corner {
    background: transparent;
    display: none !important;
  }
}

.clear {
  width: 100% !important;
  clear: both !important;
}

.empty {
  width: 100%;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
}

.vhtmlBox {
  p,
  /deep/ {
    min-height: 20px;
  }

  pre {
    display: none;
  }

  ul {
    li {
      list-style: disc;
      list-style-position: inside !important;
    }
  }

  ol {
    li {
      list-style: auto;
      list-style-position: inside !important;
    }
  }

  img {
    max-width: 100%;
  }

  video {
    border-radius: 10px;
    overflow: hidden;
    max-width: 100%;
    display: block;
  }
}

.videobox {
  video {
    display: block;
    width: 715px;
    height: 380px;
    background-color: transparent;
    object-fit: cover;
  }
}

#video_play {
  position: fixed;
  top: -999vh;
  left: -999vw;
  width: 828px;
  height: 100%;
  z-index: 99999;
  pointer-events: auto !important;
}

.van-empty__image {
  width: auto !important;
  height: auto !important;
}

.van-empty__description {
  margin-top: 22px;
}

.qcc-result-box {
  overflow: hidden;

  .qcc-result-source {
    opacity: 0.01;
    position: absolute;
    left: 0;
    bottom: -100px;
  }
}
</style>
